
<div *ngIf="this.dbCallFlag">
  <div id="gsf" *ngIf="pageGsf">
    <div class="btn-wrap">
      <div class="country-switch">
        <label _ngcontent-xnh-c42="" class="m-rgt10" for="">{{'LANGUAGE' | translate}}:</label>
          <mat-form-field>
            <mat-select [(value)]="selectedLangCode" (selectionChange)="changeLanguage(selectedLangCode)">
              <mat-option *ngFor="let language of languages" [value]="language.key" >
                {{ language.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
      </div>
    </div>
    <div class="welcomeDiv" *ngIf="publicCalculator">
      <div class="calculator-head-inner-wrap">
        <span class="calculator-head-inner" [innerHTML]="'GigatonPublicCalculator-Heading'|translate"></span>
      </div>

      <span class="calculator-head-inner-sub" [innerHTML]="'GigatonPublicCalculator-SubHeading'|translate"></span>
    </div>
    <hr class="" />
    <form>

      <div id="public-calc-pillars" class="pillar-section-wrap" *ngIf="imageConfig">

        <mat-card class="pillar-card" *ngFor="let pillar of pillars;" [routerLink]="['./',pillar]"
        [routerLinkActive]="['piller-active-tab']" >
          <img mat-card-avatar [src]="imageConfig[pillar]['src']" alt="" />
          <div class="pillar-name">
            <span *ngIf="pillar == 'deforestation'" class="">{{ "Forests" | translate }}</span>
            <span *ngIf="pillar == 'productUse'" class="">{{ "Products" | translate }}</span>
            <span *ngIf="pillar == 'others'" class="">{{
              "Other" | translate
              }}</span>
            <span *ngIf="pillar == 'packaging'" class="">{{
              "Packaging" | translate | titlecase
              }}</span>
            <span *ngIf="
                pillar != 'deforestation' &&
                pillar != 'productUse' &&
                pillar != 'others' &&
                pillar != 'packaging'
              " class="">{{ pillar | translate | titlecase}}</span>
          </div>

        </mat-card>

    </div>

    <hr class="calc-divider" />

      <div class="calc-selection-wrap">
        <div class="calc-selection-inner">
          <div class="calc-qus-layout" >


                <router-outlet></router-outlet>

          </div>


        </div>
      </div>

    </form>
  </div>
</div>
